import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "hotel-list-item-offer__container" }
const _hoisted_3 = { class: "hotel-list-item-offer__price" }

import type { OfferType } from '@/interfaces/hotel-list-types/hotel-list-types';
import { computed, toRef } from 'vue';
import type { DiscountHotelPriceOffer } from '@/interfaces/neusta-discount-price';
import { boardTypes } from '@/js/data';
import { NBSP } from '@global-js/constants';
import { getPriceTypeWording, getTotalPrice } from '@/js/utils/priceUtils';
import { useDiscount } from '../../composables/discount';
import GroupedPriceInfo from '@lmt-rpb/Molecules/GroupedPriceInfo/GroupedPriceInfo.vue';
import { storeToRefs } from 'pinia';
import { useBreakpointStore } from 'src/store/breakpointsStore';
import StayDetails from '@lmt-rpb/Atoms/StayDetails/StayDetails.vue';

type Props = {
	offer: OfferType;
	discount?: DiscountHotelPriceOffer | undefined;
	href?: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'HotelListItemOffer',
  props: {
    offer: {},
    discount: {},
    href: {}
  },
  setup(__props: any) {

const props = __props;
const { isSmallMobile } = storeToRefs(useBreakpointStore());

const isPackageOffer = computed(() => props.offer.TravelType === 'Package');
const duration = computed(() => {
	if (isPackageOffer.value) {
		return props.offer.BetweenDeparturesDuration ?? props.offer.OvernightStays;
	}

	return props.offer.OvernightStays;
});

const boardType = computed(() => {
	// eslint-disable-next-line @typescript-eslint/no-shadow
	const board = boardTypes.find((board) => board.value === props.offer.Board);
	if (!board) {
		return '';
	}
	if (isSmallMobile.value) {
		return board?.label.split(' ').join(NBSP);
	}
	return board?.label;
});
const transport = computed(() => (isPackageOffer.value ? `Inklusive${NBSP}Flug` : ''));

const totalPrice = computed((): number => getTotalPrice(props.offer.Pricing));

const { tooltipText, hasDiscount } = useDiscount(
	toRef(() => props.discount),
	totalPrice.value
);

const priceTypeWording = computed((): string => {
	const price = props.offer.Pricing.Single;

	return getPriceTypeWording({
		type: props.offer.Pricing?.Type,
		perPersonPrice: price.Converted ?? price?.Amount,
		currency: props.offer.CurrencyCode,
	});
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    href: _ctx.href,
    class: "hotel-list-item-offer"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(StayDetails, {
        class: "hotel-list-item-offer__stay-details",
        duration: duration.value + ' Tage, ',
        "board-type": `${boardType.value}${transport.value === '' ? '' : ', '}`,
        transport: transport.value
      }, null, 8 /* PROPS */, ["duration", "board-type", "transport"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(GroupedPriceInfo, {
          currency: _ctx.offer.CurrencyCode,
          "total-price": totalPrice.value,
          subtext: priceTypeWording.value,
          discount: _unref(hasDiscount) ? _ctx.discount : undefined
        }, {
          tooltip: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(tooltipText)), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["currency", "total-price", "subtext", "discount"])
      ])
    ])
  ], 8 /* PROPS */, _hoisted_1))
}
}

})